import React, { useEffect, useState } from 'react'
import {
    CheckOutlined,
    CloseOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import { Col, Empty, Input, Row, Skeleton, Table, Tabs } from 'antd';

import { useListFaq } from "../../../hooks/userFAQ";

const FaqList = (props) => {

    const { showModal } = props;

    const [pageSize, setPageSize] = useState(10);
    const [searchText, setSearchText] = useState("");

    // REACT QUERY – replaces getFaq()
    const { data: faq = [], isFetching } = useListFaq();

    const [filteredData, setFilteredData] = useState([]);


    useEffect(() => {
        setFilteredData(faq);
    }, [faq])

    const columns = [
        {
            title: "Question",
            dataIndex: "question",
            key: "col-1",
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: "Answer",
            dataIndex: "answer",
            key: "col-2",
            showOnResponse: true,
            showOnDesktop: true,
            render: (_, record) => {
                return (
                    <>
                        <div dangerouslySetInnerHTML={{ __html: record.answer }}></div>
                    </>
                );
            },
        },
        {
            title: "Confidential",
            dataIndex: "confidencial",
            key: "title-3",
            showOnResponse: true,
            showOnDesktop: true,
            render: (value) =>
                value === true ? (
                    <CheckOutlined
                        style={{
                            fontSize: "18px",
                            color: "#04a596",
                            fontWeight: "bold",
                        }}
                    />
                ) : (
                    <CloseOutlined
                        style={{
                            fontSize: "18px",
                            color: "#a21b1b",
                            fontWeight: "bold",
                        }}
                    />
                ),
        },

        {
            title: "Archived",
            dataIndex: "archived",
            key: "title-4",
            showOnResponse: true,
            showOnDesktop: true,

            render: (value) =>
                value === true ? (
                    <CheckOutlined
                        style={{
                            fontSize: "18px",
                            color: "#04a596",
                            fontWeight: "bold",
                        }}
                    />
                ) : (
                    <CloseOutlined
                        style={{
                            fontSize: "18px",
                            color: "#a21b1b",
                            fontWeight: "bold",
                        }}
                    />
                ),
        },
        {
            title: "Actions",
            dataIndex: "edit",
            showOnResponse: true,
            showOnDesktop: true,
            render: (_, record) => {
                return (
                    <>
                        <a
                            key={"a-" + record.id}
                            onClick={() => showModal(record, "edit")}
                        >
                            Edit
                        </a>
                    </>
                );
            },
        },
    ];


    const onRowChange = (row) => setPageSize(row.pageSize);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);

        if (!value) {
            setFilteredData(faq);
            return;
        }

        const reg = new RegExp(value, "gi");

        const results = faq.filter((item) => item.question?.match(reg) || item.answer?.match(reg)
        );

        setFilteredData(results);
    };

    return (
        <>
            <div key={"div-faq-list"}>List of Frequently Asked Questions</div>
            <Row>
                <Col xs={24} md={8}>
                    <Input
                        placeholder="Search FAQ"
                        type="text"
                        className="search-bar"
                        onChange={handleSearch}
                        allowClear
                        size="large"
                        prefix={<SearchOutlined />}
                    />
                </Col>
            </Row>
            <div className="space"></div>
            <Tabs
                className=""
                type="card"
                key="tab-1" />
            <div className="space"></div>

            <Table
                dataSource={isFetching ? [] : filteredData}
                locale={{
                    emptyText: isFetching ? <Skeleton active /> : <Empty />,
                }}
                rowKey={(record) => record.id}
                columns={columns}
                bordered
                pagination={{ pageSize }}
                onChange={onRowChange}
            />

        </>
    )
}

export default FaqList;